import { render, staticRenderFns } from "./reportesRutas.vue?vue&type=template&id=64c63694&"
import script from "./reportesRutas.vue?vue&type=script&lang=js&"
export * from "./reportesRutas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports